<template>
  <div class="label">
    <div class="search fixed_horizo_center">
      <van-search v-model="name" placeholder="请输入标签名称" @clear="searchCustomer" />
      <span :span="4" @click="searchCustomer" class="search-text">搜索</span>
    </div>
    <div class="content">
      <ul v-for="item in labelOption" :key="item.group_id" class="label-ul">
        <h3>{{ item.group_name }}</h3>
        <li>
          <span v-for="label in item.tag" :key="label.id" @click="chooseLabel(label)" :class="{ activetag: isInclude(selectArr, label) }">{{ label.name }}</span>
        </li>
      </ul>
    </div>
    <div class="fixed_bottom fixed_horizo_center">
      <div class="button_bottom">
        <dl @click="resetTag" ref="resetBtn">重置</dl>
        <dl @click="ensureComfirm" ref="ensureConfirm">
          <span>确认</span>
          <span v-show="selectArr.length > 0">{{ "(" + selectArr.length + ")" }}</span>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import { wxConfig } from "../fastReply/js/config";
import { addressBar } from "@/utils/public";
import { listGroupTag, corpAddTag } from "@/server/api.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      name: "",
      selectArr: [],
      labelOption: [],
      wechatUserId: "",
      formatTags: [],
      userInfo: {},
      windowurl: window.location.href.split("#")[0] || "http://tm-qw.1000phone.net/setLabel",
      jsList: ["getCurExternalContact"],
    };
  },
  mounted() {
    if (localStorage.getItem("token")) {
      wxConfig(this.windowurl, this.jsList).then(() => {
        this.hasuserid();
      });
    } else {
      addressBar("token", this.windowurl);
    }
  },
  watch: {
    selectArr(val) {
      if (val.length > 0) {
        this.$refs.resetBtn.classList.add("resetTag");
        this.$refs.ensureConfirm.style.opacity = 1;
      } else {
        this.$refs.resetBtn.classList.remove("resetTag");
        this.$refs.ensureConfirm.style.opacity = 0.5;
      }
    },
  },
  methods: {
    hasuserid() {
      let that = this;
      wx.invoke("getCurExternalContact", {}, function (res) {
        if (res.userId) {
          that.wechatUserId = res.userId;
          that.labelList();
        }
      });
    },
    labelList() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      listGroupTag({ deptId: this.userInfo?.zsGroupId }).then((res) => {
        if (res.code === "200") {
          this.labelOption = res.data.tagGroups;
          this.formatTags = [...this.labelOption];
        } else {
          return Toast.fail(res.msg);
        }
      });
    },
    searchCustomer() {
      if (!this.name) {
        return (this.labelOption = [...this.formatTags]);
      }
      let newarr = [];
      this.formatTags.map((item) => {
        if (item.group_name.indexOf(this.name) > -1) {
          newarr.push(item);
        }
        item.tag.filter((j) => {
          if (j.name.indexOf(this.name) > -1) {
            newarr.push(item);
          }
        });
      });
      this.labelOption = [...new Set(newarr)];
    },
    chooseLabel(obj) {
      let index = this.selectArr.findIndex((val) => {
        return val.id === obj.id;
      });
      if (index > -1) {
        this.selectArr.splice(index, 1);
      } else {
        this.selectArr.push(obj);
      }
    },
    isInclude(arr, label) {
      return arr.find((item) => {
        return item.id == label.id;
      });
    },
    resetTag() {
      this.selectArr = [];
    },
    ensureComfirm() {
      let add_tag = [];
      this.selectArr.map((v) => {
        add_tag.push({ name: v.name, id: v.id });
      });
      let userid = localStorage.getItem("userid");
      let addTagUser = [
        {
          userid,
          external_userid: this.wechatUserId,
        },
      ];
      corpAddTag({ add_tag, addTagUser, remove_tag: [] }).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        Toast.success("保存成功");
        setTimeout(() => {
          wx.closeWindow();
        }, 2000);
      });
    },
  },
};
</script>
<style scoped lang="less">
.label {
  width: 100%;
  min-height: 100%;
  background: #f6f6f6;
  padding-top: 124px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  .search {
    display: flex;
    align-items: center;
    background: #fff;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 100;
    margin-bottom: 20px;
    padding: 20px 30px;
    .van-search {
      flex: 1;
      /deep/.van-icon-search {
        font-size: 28px;
      }
      /deep/.van-field__control {
        font-size: 28px;
      }
    }
    .van-search__content {
      height: 80px;
      padding-left: 30px;
      border-radius: 40px;
      background-color: #f3f3f3;
    }
    .van-search .van-cell {
      align-items: center;
    }
    .van-field__left-icon {
      height: 80px;
    }
    span {
      font-size: 32px;
      padding-right: 20px;
      cursor: pointer;
    }
  }
  .content {
    padding: 20px 30px;
    margin-bottom: 122px;
    .label-ul {
      background: #fff;
      margin-bottom: 18px;
      border-radius: 14px;
      padding: 24px;
      h3 {
        font-size: 32px;
        color: #333333;
      }
      li {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        span {
          background-color: #f2f2f2;
          padding: 9px 21px;
          color: #999999;
          border-radius: 8px;
          margin: 0 20px 20px 0;
          font-size: 24px;
          border: 1px solid #f2f2f2;
        }
        .activetag {
          color: #277fff;
          border: 1px solid #a5caff;
          background: #e0edff;
        }
      }
    }
  }
  .fixed_bottom {
    position: fixed;
    left: 50%;
    bottom: 0;
    background-color: #f6f6f6;
    width: 100%;
    max-width: 748px;
    transform: translate(-50%, 0);
  }
}
</style>
